import "./Buying.css";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";

import { Button, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { buyingColorAssocObj, colorStyleAssocObj, colorImgAssociationObjName, channelTypes } from "./data";
import { converAttrToDatagridCol, imageTableColumn, publishColumns, stageTableColumn, styleImageColumn } from "data/globalData";
import { grey } from "@mui/material/colors";
import { GlobalState } from "context/GlobalContext";
import axios from "axios";

import { AmountConverter } from "components/ReusableComponents/InLakhsDisplay";
import { PimDashboardState } from "context/PimDashboardContext";
import { attrGroupLinkedTables, productionStageOptions, publishTableColumn, selectedBuyPagePath } from "components/PimDashboard/data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { FileDownloadRounded, FilterAltRounded, PlaylistAddRounded } from "@mui/icons-material";
import FileSaver from "file-saver";
import AddColumnModal from "../../Designer/StylesDashboard/AddColumnModal/AddColumnModal";
import FilterModal from "../../Designer/StylesDashboard/FilterModal/FilterModal";
import { lsBuyingFilterValStr, lsFabricTrimsFilterValStr } from "../../Designer/StylesDashboard/data";
import { BuyingDashboardState } from "context/BuyingDashboardContext";
import { useNavigate } from "react-router-dom";

const lineHeight = {
	lineHeight: 3.1,
};
export const BuyingBox = ({ data }) => {
	let imgWidth = 50;
	let imgHeight = 60;
	let selectedColor = data[buyingColorAssocObj];
	let colorStyle = selectedColor ? selectedColor[colorStyleAssocObj] : {};
	let imageUrl = selectedColor
		? selectedColor[colorImgAssociationObjName]
			? selectedColor[colorImgAssociationObjName][0].url
			: ""
		: "";

	return (
		<Box width="100%" display="flex" alignItems="center">
			<img
				style={{
					width: `${imgWidth}px`,
					height: `${imgHeight}px`,
					objectFit: "cover",
					objectPosition: "50% 0%",
					borderRadius: 2,
				}}
				src={imageUrl}
			/>
			<Stack pl={1} justifyContent="space-between" rowGap={1}>
				<Typography variant="body1" width="100%" fontSize={18} fontWeight={600}>
					{colorStyle?.style_name}
				</Typography>
				<Box display="flex" columnGap={1} alignItems="center">
					<Chip label={selectedColor?.color} size="small" />
					<Typography variant="body1" fontSize={14}>
						{selectedColor?.pallete}
					</Typography>
				</Box>
			</Stack>
		</Box>
	);
};
export const RenderStyleColumns = ({ data, column }) => {
	let selectedColor = data[buyingColorAssocObj];
	let colorStyle = selectedColor ? selectedColor[colorStyleAssocObj] : {};
	// let imageUrl = selectedColor
	// 	? selectedColor[colorImgAssociationObjName]
	// 		? selectedColor[colorImgAssociationObjName][0].url
	// 		: ""
	// 	: "";

	return (
		<Typography sx={lineHeight} variant="subtitle2">
			{colorStyle[column]}
		</Typography>
	);
};
export const RenderColorColumns = ({ data, column }) => {
	let selectedColor = data[buyingColorAssocObj] ? data[buyingColorAssocObj] : {};

	return (
		<Typography sx={lineHeight} variant="subtitle2">
			{selectedColor[column]}
		</Typography>
	);
};

export const TotalChannelUI = ({ qtyBuying, buyingListQty }) => (
	<Box display="flex" alignItems="center" flexDirection="row">
		{Object.keys(channelTypes).map((chan) => {
			let obj = channelTypes[chan];
			return (
				<Box display="flex" alignItems="center" justifyContent="center" flexDirection="row" p="0px 5px">
					<Typography fontWeight={600} textAlign="center" color="grey">{`${obj.key} : `}</Typography>
					<AmountConverter sx={{ fontWeight: "600" }} number={qtyBuying[obj.key]} />
				</Box>
			);
		})}
		<Box display="flex" alignItems="center" flexDirection="row" p="0px 5px">
			<Typography fontWeight={600} color="grey">{`Total : `}</Typography>
			<AmountConverter sx={{ fontWeight: "600" }} number={buyingListQty} />
		</Box>
	</Box>
);

const BuyingSheet = () => {
	const navigate = useNavigate();
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { setDistinctSizeMaster, distinctSizeMaster, allAttributesObj, allAttributes } = PimDashboardState();
	const { buyingList, setBuyingList } = BuyingDashboardState();

	const [editModal, setEditModal] = useState(false);
	const [filterModal, setFilterModal] = useState(false);
	const [addColumnModal, setAddColumnModal] = useState(false);
	const [displayImg, setDisplayImg] = useState(true);
	const [gridSelectedRow, setGridSelectedRow] = useState({});
	const [filterColumns, setFilterColumns] = useState(
		// appling filter fron local storage data
		() => {
			let final = [];
			if (localStorage.getItem(lsBuyingFilterValStr)) {
				const localStorageObj =
					typeof JSON.parse(localStorage.getItem(lsBuyingFilterValStr)) === "object"
						? JSON.parse(localStorage.getItem(lsBuyingFilterValStr))
						: {};
				[
					...allAttributes,
					...Object.keys(publishColumns).map((row) => publishColumns[row]),
					stageTableColumn(productionStageOptions),
				]?.forEach((row) => {
					if (localStorageObj?.[row?.key]) final.push(row);
				});
				return final;
			}
		}
	);
	const [filterColumnVal, setFilterColumnVal] = useState(() => {
		if (localStorage.getItem(lsBuyingFilterValStr)) {
			return JSON.parse(localStorage.getItem(lsBuyingFilterValStr));
		} else {
			return {};
		}
	});
	const [tableColumns, setTableColumns] = useState();
	const [offset, setOffset] = useState(0);
	const [pendingCount, setPendingCount] = useState(0);

	const [attrColumns, setAttrColumns] = useState(() => {
		if (localStorage.getItem("buying_table_column_Arr")) {
			return JSON.parse(localStorage.getItem("buying_table_column_Arr"))
				?.map((row) => {
					return { ...allAttributesObj?.[row] };
				})
				.map((row) => converAttrToDatagridCol(row));
		} else
			return [
				...allAttributes
					?.filter((row) => row?.linked_table === attrGroupLinkedTables.color.key)
					?.map((row) => converAttrToDatagridCol(row)),
				...allAttributes
					?.filter((row) => row?.key === "style_name" || row?.key === "style_id")
					?.map((row) => converAttrToDatagridCol(row)),
			];
	});

	const fetch1 = async () => {
		setLoadingOpen(true);
		try {
			await axios.get("/api/master/get_distinct_sizes_with_brand_cat").then((res) => {
				// console.log("get_size_type_master", res?.data);
				setDistinctSizeMaster(res?.data?.result);
			});
			setLoadingOpen(false);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Server Error for size types `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const fetch = async () => {
		setLoadingOpen(true);
		setTableColumns([
			// publishTableColumn(() => {}, !allowAccess(custom.STYLE_PUBLISHER, user, departments.BUYING_PLANNING.key)),
			imageTableColumn(styleImageColumn),
			...attrColumns,
			...Object.keys(publishColumns)
				.filter((row) => row !== "status")
				?.map((row) => converAttrToDatagridCol(publishColumns[row])),
			publishTableColumn(null, true),
			stageTableColumn(productionStageOptions),
		]);
		// convertAttrColumns to obj (they are in datagrid col format)
		const extraColumns = attrColumns?.reduce((acc, row) => {
			acc[row.field] = true;
			return acc;
		}, {});
		try {
			await axios
				.post(`/api/color_buying/get_total_buying/${offset}`, { filter: filterColumnVal, extraColumns, limit: 50 })
				.then((res) => {
					setBuyingList(res.data);
				});
			setLoadingOpen(false);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	useEffect(() => {
		fetch();
		!distinctSizeMaster && fetch1();
	}, [filterColumns, attrColumns]);

	const handleImageSwitchChange = (checked) => {
		setDisplayImg(checked);
	};

	const handleCloseChannelBuyClose = () => {
		setEditModal(false);
	};

	const handleRowClick = (row, e) => {
		navigate(`/${selectedBuyPagePath}?id=${row.id}`);
	};

	const handleCloseFilterModal = () => {
		setFilterModal(false);
	};
	const handleCloseAddColumnModal = () => {
		setAddColumnModal(false);
	};
	const handleFilterClick = () => {
		setFilterModal(true);
	};
	const handleAddColumnClick = () => {
		setAddColumnModal(true);
	};
	const handleDownloadClick = async () => {
		setLoadingOpen(true);
		try {
			await axios({
				url: `/api/color_buying/download_buying_sheet`,
				method: "GET",
				responseType: "blob",
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `allStyles.xlsx`);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};
	return (
		<Stack width="100%" spacing={1} pt={1}>
			<Stack display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
				<Stack spacing={1} width="28%">
					<Box display="flex" columnGap={1} pt={1} flexWrap="wrap" alignItems="center">
						<Button
							variant="contained"
							size="small"
							startIcon={<FilterAltRounded />}
							onClick={handleFilterClick}
							sx={{ textTransform: "capitalize" }}>
							Filter
						</Button>{" "}
						:
						{!filterColumns?.length && (
							<Typography variant="body1" fontSize={16} color={grey[700]}>
								None
							</Typography>
						)}
						{filterColumns?.map((row) => {
							return (
								<Chip
									label={`${row.name} : ${
										Array.isArray(filterColumnVal[row?.key])
											? filterColumnVal[row?.key]?.join(", ")
											: filterColumnVal?.[row?.key]
									}`}
									size="small"
								/>
							);
						})}
					</Box>
					<Box>
						<Button
							variant="contained"
							sx={{ textTransform: "capitalize", mr: 1 }}
							size="small"
							onClick={handleAddColumnClick}
							startIcon={<PlaylistAddRounded />}>
							Manage Columns
						</Button>
						<Button
							variant="contained"
							size="small"
							sx={{ textTransform: "capitalize" }}
							onClick={handleDownloadClick}
							startIcon={<FileDownloadRounded />}>
							Download
						</Button>
					</Box>
				</Stack>

				{/* <TotalChannelUI qtyBuying={qtyBuying} buyingListQty={buyingListQty} /> */}
			</Stack>
			<Box display="flex" justifyContent="space-between" alignItems="center" pt={2}>
				<Box display="flex" alignItems="center">
					<Typography variant="h6">Images</Typography>
					<Switch checked={displayImg} onChange={(e) => handleImageSwitchChange(e.target.checked)} sx={{ mt: 1 }} />
				</Box>
				<Box>
					<Typography variant="h6">
						Pending <span style={{ color: "red" }}>{pendingCount}</span>
					</Typography>
				</Box>
			</Box>
			<Stack width="100%" height={400}>
				<DataGrid
					rows={buyingList}
					columns={tableColumns ?? []}
					key={displayImg}
					sx={{
						minHeight: 350,
						maxHeight: 430,
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							// border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
						"& .MuiDataGrid-footer": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					columnHeaderHeight={35}
					rowHeight={displayImg ? 60 : 40} //   processRowUpdate={processRowUpdate}
					onProcessRowUpdateError={(error) => console.log(error)}
					// showCellVerticalBorder
					// onRowClick={(params, e) => handleStyleSelect(params.row)}
					onRowClick={(params, e) => {
						handleRowClick(params.row, e);
					}}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 10 },
						},
						columns: {
							columnVisibilityModel: {
								url: displayImg,
							},
						},
					}}
					// loading={loading}
					disableRowSelectionOnClick
					pageSizeOptions={[10, 50]}
				/>
			</Stack>

			<AddColumnModal
				modal={addColumnModal}
				handleCloseModal={handleCloseAddColumnModal}
				attrColumns={attrColumns}
				setAttrColumns={setAttrColumns}
				localStorageStr={"buying_table_column_Arr"}
			/>
			<FilterModal
				modal={filterModal}
				handleCloseModal={handleCloseFilterModal}
				filterColumns={filterColumns}
				setFilterColumns={setFilterColumns}
				filterColumnVal={filterColumnVal}
				setFilterColumnVal={setFilterColumnVal}
				localStorageStr={lsBuyingFilterValStr}
			/>
		</Stack>
	);
};

export default BuyingSheet;
